import { RolesEnum } from '@/items/Roles';
export const excludeRoles = {
    // versie 1
    1: {
        navigationItems: {
            scoolDesk: [RolesEnum.STUDENT, RolesEnum.TEACHER, RolesEnum.ADMIN],
            scoolUsers: {
                guardians: [RolesEnum.STUDENT, RolesEnum.TEACHER, RolesEnum.ADMIN],
                supervisors: [RolesEnum.ADMIN],
                resellers: [RolesEnum.ADMIN],
            },
            scoolAdmin: {
                rooms: [RolesEnum.ADMIN],
                lesTypes: [RolesEnum.ADMIN],
                school: [RolesEnum.ADMIN],
            },
            scoolDrive: [RolesEnum.STUDENT],
            scoolMessenger: [RolesEnum.STUDENT],
            scoolPlanner: [RolesEnum.STUDENT, RolesEnum.TEACHER, RolesEnum.ADMIN],
            scoolPlannerSettings: [RolesEnum.ADMIN],
        },
        scoolUsers: {
            dashboard: [RolesEnum.STUDENT, RolesEnum.TEACHER, RolesEnum.GUARDIAN],
            table: {
                actions: [RolesEnum.TEACHER, RolesEnum.ADMIN],
            },
            detail: {
                navigationItems: [RolesEnum.STUDENT, RolesEnum.TEACHER, RolesEnum.ADMIN],
                tracker: {
                    date: [RolesEnum.STUDENT, RolesEnum.GUARDIAN, RolesEnum.TEACHER, RolesEnum.SUPERVISOR, RolesEnum.RESELLER, RolesEnum.ADMIN],
                },
                periods: [RolesEnum.TEACHER, RolesEnum.ADMIN],
                profile: [RolesEnum.TEACHER, RolesEnum.ADMIN],
            },
        },
        curriculum: {
            subject: [RolesEnum.STUDENT, RolesEnum.GUARDIAN, RolesEnum.TEACHER, RolesEnum.SUPERVISOR, RolesEnum.RESELLER, RolesEnum.ADMIN],
        },
        scoolGroups: {
            navigationItems: {
                messenger: [RolesEnum.STUDENT, RolesEnum.GUARDIAN, RolesEnum.TEACHER, RolesEnum.SUPERVISOR, RolesEnum.RESELLER, RolesEnum.ADMIN],
            },
        },
        scoolAdmin: {
            years: {
                date: [RolesEnum.STUDENT, RolesEnum.GUARDIAN, RolesEnum.TEACHER, RolesEnum.SUPERVISOR, RolesEnum.RESELLER, RolesEnum.ADMIN],
            },
            schools: {
                settings: {
                    version: [RolesEnum.STUDENT, RolesEnum.GUARDIAN, RolesEnum.TEACHER, RolesEnum.SUPERVISOR, RolesEnum.RESELLER, RolesEnum.ADMIN],
                },
            },
        },
    },
    // versie 2a
    4: {
        navigationItems: {
            scoolDesk: [''],
            scoolUsers: {
                guardians: [''],
                supervisors: [''],
                resellers: [''],
            },
            scoolAdmin: {
                rooms: [RolesEnum.ADMIN],
                lesTypes: [RolesEnum.ADMIN],
                school: [''],
            },
            scoolDrive: [''],
            scoolMessenger: [''],
            scoolPlanner: [RolesEnum.STUDENT, RolesEnum.TEACHER, RolesEnum.ADMIN],
            scoolPlannerSettings: [RolesEnum.ADMIN],
        },
        scoolUsers: {
            dashboard: [RolesEnum.STUDENT, RolesEnum.TEACHER, RolesEnum.GUARDIAN],
            table: {
                actions: [''],
            },
            detail: {
                navigationItems: [''],
                tracker: {
                    date: [RolesEnum.STUDENT, RolesEnum.GUARDIAN, RolesEnum.TEACHER, RolesEnum.SUPERVISOR, RolesEnum.RESELLER, RolesEnum.ADMIN],
                },
                periods: [''],
                profile: [''],
            },
        },
        curriculum: {
            subject: [''],
        },
        scoolGroups: {
            navigationItems: {
                messenger: [''],
            },
        },
        scoolAdmin: {
            years: {
                date: [RolesEnum.STUDENT, RolesEnum.GUARDIAN, RolesEnum.TEACHER, RolesEnum.SUPERVISOR, RolesEnum.RESELLER, RolesEnum.ADMIN],
            },
            schools: {
                settings: {
                    version: [RolesEnum.STUDENT, RolesEnum.GUARDIAN, RolesEnum.TEACHER, RolesEnum.SUPERVISOR, RolesEnum.RESELLER, RolesEnum.ADMIN],
                },
            },
        },
    },
    // versie 2b
    2: {
        navigationItems: {
            scoolDesk: [''],
            scoolUsers: {
                guardians: [''],
                supervisors: [''],
                resellers: [''],
            },
            scoolAdmin: {
                rooms: [RolesEnum.ADMIN],
                lesTypes: [RolesEnum.ADMIN],
                school: [''],
            },
            scoolDrive: [''],
            scoolMessenger: [''],
            scoolPlanner: [RolesEnum.STUDENT, RolesEnum.TEACHER, RolesEnum.ADMIN],
            scoolPlannerSettings: [RolesEnum.ADMIN],
        },
        scoolUsers: {
            dashboard: [RolesEnum.STUDENT, RolesEnum.TEACHER, RolesEnum.GUARDIAN],
            table: {
                actions: [''],
            },
            detail: {
                navigationItems: [RolesEnum.TEACHER, RolesEnum.ADMIN],
                tracker: {
                    date: [''],
                },
                periods: [''],
                profile: [''],
            },
        },
        curriculum: {
            subject: [''],
        },
        scoolGroups: {
            navigationItems: {
                messenger: [''],
            },
        },
        scoolAdmin: {
            years: {
                date: [''],
            },
            schools: {
                settings: {
                    version: [RolesEnum.STUDENT, RolesEnum.GUARDIAN, RolesEnum.TEACHER, RolesEnum.SUPERVISOR, RolesEnum.RESELLER, RolesEnum.ADMIN],
                },
            },
        },
    },
    // versie 3
    3: {
        navigationItems: {
            scoolDesk: [''],
            scoolUsers: {
                guardians: [''],
                supervisors: [''],
                resellers: [''],
            },
            scoolAdmin: {
                rooms: [''],
                lesTypes: [''],
                school: [''],
            },
            scoolDrive: [''],
            scoolMessenger: [''],
            scoolPlanner: [RolesEnum.STUDENT, RolesEnum.TEACHER, RolesEnum.ADMIN],
            scoolPlannerSettings: [RolesEnum.ADMIN],
        },
        scoolUsers: {
            dashboard: [''],
            table: {
                actions: [''],
            },
            detail: {
                navigationItems: [''],
                tracker: {
                    date: [''],
                },
                periods: [''],
                profile: [''],
            },
        },
        curriculum: {
            subject: [''],
        },
        scoolGroups: {
            navigationItems: {
                messenger: [''],
            },
        },
        scoolAdmin: {
            years: {
                date: [''],
            },
            schools: {
                settings: {
                    version: [RolesEnum.STUDENT, RolesEnum.GUARDIAN, RolesEnum.TEACHER, RolesEnum.SUPERVISOR, RolesEnum.RESELLER, RolesEnum.ADMIN],
                },
            },
        },
    },
};
